import axios from 'axios';
import { API_BASE_URL } from '../config';

// API 경로 접두사
const API_PATH_PREFIX = '/api/v1';

// axios 인스턴스 생성
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API 요청 경로 생성 함수
const getApiPath = (path) => {
  return `${API_PATH_PREFIX}${path}`;
};

export const fetchImages = async (filters = {}, page = 1, limit = 100) => {
  try {
    console.log('Fetching images with params:', { filters, page, limit });
    
    // 필터 파라미터 처리 로직 수정
    const filterParams = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        filterParams[key] = value;
      }
    });

    const requestConfig = {
      params: {
        ...filterParams,
        page: page,
        limit: limit
      },
      paramsSerializer: {
        indexes: null
      },
      timeout: 5000
    };
    
    // URL이 어떻게 생성되는지 확인
    const url = api.getUri({
      url: getApiPath('/images'),
      ...requestConfig
    });
    console.log('Request URL:', url);
    
    const response = await api.get(getApiPath('/images'), requestConfig);
    console.log('Server response:', response);
    console.log('Response data structure:', {
      type: typeof response.data,
      isArray: Array.isArray(response.data),
      length: Array.isArray(response.data) ? response.data.length : 'N/A',
      sample: Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : null
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching images:', error);
    if (error.code === 'ECONNREFUSED') {
      throw new Error('서버에 연결할 수 없습니다. 서버가 실행 중인지 확인해주세요.');
    }
    if (error.response) {
      throw new Error(`서버 오류: ${error.response.status} - ${error.response.data.detail || '알 수 없는 오류'}`);
    } else if (error.request) {
      throw new Error('서버로부터 응답이 없습니다. 서버 상태를 확인해주세요.');
    }
    throw new Error(`요청 중 오류가 발생했습니다: ${error.message}`);
  }
};

// 이미지 총 개수 가져오기
export const fetchImageCount = async (filters = {}) => {
  try {
    console.log('Fetching image count with filters:', filters);
    
    // 필터 파라미터 처리 로직
    const filterParams = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        filterParams[key] = value;
      }
    });

    const response = await api.get(getApiPath('/images/count'), {
      params: filterParams,
      paramsSerializer: {
        indexes: null
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching image count:', error);
    throw error;
  }
};

// 미용실 목록 가져오기
export const fetchSalons = async (cursor = 0, limit = 100) => {
  try {
    const response = await api.get(getApiPath('/salons'), {
      params: {
        cursor: cursor,
        limit: limit
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching salons:', error);
    throw error;
  }
};

// 디자이너 목록 가져오기
export const fetchDesigners = async (cursor = 0, limit = 100) => {
  try {
    const response = await api.get(getApiPath('/salons/designers'), {
      params: {
        cursor: cursor,
        limit: limit
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching designers:', error);
    throw error;
  }
};

// 헤어 스타일 목록 가져오기
export const fetchHairStyles = async () => {
  try {
    const response = await api.get(getApiPath('/hair/hair-styles'));
    return response.data;
  } catch (error) {
    console.error('Error fetching hair styles:', error);
    throw error;
  }
};

// 헤어 길이 목록 가져오기
export const fetchHairLengths = async () => {
  try {
    const response = await api.get(getApiPath('/hair/hair-lengths'));
    return response.data;
  } catch (error) {
    console.error('Error fetching hair lengths:', error);
    throw error;
  }
};

// 앞머리 목록 가져오기
export const fetchBangs = async () => {
  try {
    const response = await api.get(getApiPath('/hair/bangs'));
    return response.data;
  } catch (error) {
    console.error('Error fetching bangs:', error);
    throw error;
  }
};

// 헤어 색상 목록 가져오기
export const fetchHairColors = async () => {
  try {
    const response = await api.get(getApiPath('/hair/hair-colors'));
    return response.data;
  } catch (error) {
    console.error('Error fetching hair colors:', error);
    throw error;
  }
};

// LoRA 모델 목록 가져오기
export const fetchLoraModels = async () => {
  try {
    const response = await api.get(getApiPath('/lora-models'));
    return response.data;
  } catch (error) {
    console.error('Error fetching LoRA models:', error);
    throw error;
  }
};

// LoRA 모델 생성하기
export const createLoraModel = async (name) => {
  try {
    const response = await api.post(getApiPath('/lora-models'), { name });
    return response.data;
  } catch (error) {
    console.error('Error creating LoRA model:', error);
    throw error;
  }
};

// 이미지 레코드 업데이트
export const updateImageRecord = async (imageId, data) => {
  try {
    // 새로운 API 엔드포인트에 맞게 요청 형식 변경
    const requestData = {
      id: imageId,
      ...data
    };
    
    const response = await api.patch(getApiPath('/images'), requestData);
    return response.data;
  } catch (error) {
    console.error(`Error updating image record ${imageId}:`, error);
    throw error;
  }
};

// 여러 이미지 레코드 일괄 업데이트
export const updateImageRecords = async (imageUpdates) => {
  try {
    // 새로운 API 엔드포인트에 맞게 요청 형식 변경
    const requestData = {
      images: imageUpdates
    };
    
    const response = await api.patch(
      getApiPath('/images/batch'),
      requestData
    );
    return response.data;
  } catch (error) {
    console.error('Error updating image records:', error);
    throw error;
  }
};

export default api; 